<template>
	<div class="add-item-option-group">
		<div class="title" tabindex="0" :aria-label="getAriaLabel()">
			{{ title }}
			<span v-if="required" class="required-badge">Required</span>
		</div>
		<p class="choose-between-text">
			{{ getChooseBetweenText() }}
		</p>
		<div v-if="type == 2" class="choices-group">
			<add-item-input-radio
				v-for="choice in choices"
				:key="choice.id"
				:id="choice.id"
				:value="choice.value"
				:name="choice.name"
				:label="choice.name"
				:price="choice.price"
				:isAlcohol="choice.isAlcohol"
				:hasNestedOptions="hasNestedOptions(choice.id)"
				:allNestedOptionsSelected="allNestedOptionsSelected"
				@input="handleOneSelect"
				@editNestedSelections="handleEditNestedSelections"
			/>
		</div>
		<div v-else class="choices-group">
			<add-item-input-checkbox
				v-for="choice in choices"
				:key="choice.id"
				:id="choice.id"
				:label="choice.name"
				:value="choice.value"
				:price="choice.price"
				:isAlcohol="choice.isAlcohol"
				:hasNestedOptions="hasNestedOptions(choice.id)"
				:allNestedOptionsSelected="allNestedOptionsSelected"
				@input="handleManySelect"
				@editNestedSelections="handleEditNestedSelections"
			/>
		</div>
	</div>
</template>

<script>
import AddItemInputRadio from "./AddItemInputRadio.vue";
import AddItemInputCheckbox from "./AddItemInputCheckbox.vue";

export default {
	name: "AddItemChoices",
	props: {
		title: {
			type: String,
		},
		choices: {
			type: Array,
			default: () => [],
		},
		nestedOptionGroups: {
			type: Object,
			default: () => {},
		},
		name: {
			type: String,
		},
		id: {
			type: String,
		},
		type: {
			type: Number,
		},
		atLeast: {
			type: Number,
		},
		atMost: {
			type: Number,
		},
		required: {
			type: Number,
		},
		allNestedOptionsSelected: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		AddItemInputRadio,
		AddItemInputCheckbox,
	},
	methods: {
		hasNestedOptions(optionID) {
			// Checking if optionID is a key in nestedOptionGroups meaning this optionID is the parentID for at least 1 nestedOptionGroup
			if (optionID in this.nestedOptionGroups) {
				return true;
			}
			return false;
		},
		handleEditNestedSelections(optionId) {
			this.$emit("editNestedSelections", optionId);
		},
		handleManySelect(payload) {
			if (this.hasNestedOptions(payload.optionId)) {
				this.$emit("chooseManyInput", {
					optionId: payload.optionId,
					optionGroupId: this.id,
					hasNestedOptions: true,
					optionGroupName: this.title,
					optionName: payload.optionName,
					price: payload.price,
				});
			} else {
				this.$emit("chooseManyInput", {
					optionId: payload.optionId,
					optionGroupId: this.id,
					hasNestedOptions: false,
					optionGroupName: this.title,
					optionName: payload.optionName,
					price: payload.price,
				});
			}
		},
		handleOneSelect(payload) {
			if (this.hasNestedOptions(payload.optionId)) {
				this.$emit("chooseOneInput", {
					optionGroupId: this.id,
					optionId: payload.optionId,
					hasNestedOptions: true,
					optionGroupName: this.title,
					optionName: payload.optionName,
					price: payload.price,
				});
			} else {
				this.$emit("chooseOneInput", {
					optionGroupId: this.id,
					optionId: payload.optionId,
					hasNestedOptions: false,
					optionGroupName: this.title,
					optionName: payload.optionName,
					price: payload.price,
				});
			}
		},
		getChooseBetweenText() {
			if (this.required && !this.atLeast && !this.atMost) {
				return "(choose 1)";
			} else if (this.required && this.atLeast && this.atMost > 1) {
				return `(choose between ${this.atLeast} - ${this.atMost})`;
			} else if (!this.atLeast && this.atMost) {
				return `(choose up to ${this.atMost})`;
			} else {
				return "";
			}
		},
		getAriaLabel() {
			const requiredText = this.required ? " required " : " ";
			return `${this.title} ${requiredText} ${this.getChooseBetweenText()}`;
		},
	},
};
</script>

<style lang="scss" scoped>
.add-item-option-group {
	border-top: 1px solid $gray_1;
	padding: 15px 5px;
}

.title {
	font-weight: 900;
	font-size: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.choices-group {
	margin-bottom: 25px;
}

.choose-between-text {
	text-align: center;
	margin-bottom: 15px;
}

.required-badge {
	font-size: 12px;
	padding: 2px 8px;
	background-color: #93999c;
	border-radius: 4px;
	box-shadow: 1px 1px 5px 0 rgba(171, 168, 168, 0.5);
	color: white;
	margin: 0 5px;
	font-weight: 400;
}
</style>